import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IValidateSessionState, IValidateSessionData } from './types';

const initState: IValidateSessionState = {
  data: null,
  isLoading: false,
};

function onValidateSessionRequest(state: IValidateSessionState) {
  return { ...state, isLoading: true };
}

function onValidateSessionSuccess(state: IValidateSessionState, { payload }: { payload: IValidateSessionData }) {
  return { ...state, data: payload, isLoading: false };
}

function onValidateSessionError(state: IValidateSessionState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.VALIDATE_SESSION_REQUEST]: onValidateSessionRequest,
  [actions.VALIDATE_SESSION_SUCCESS]: onValidateSessionSuccess,
  [actions.VALIDATE_SESSION_ERROR]: onValidateSessionError,
});
